import { UploadFileOutlined } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as React from "react";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Axios.jsx";
import useAuth from "../../contexts/UserContext.tsx";
import { toast } from "sonner";

export default function AddCommunicationDialog({
  open,
  onClose,
  schoolName,
  communicationTypes,
}) {
  const { user } = useAuth();
  const { id } = useParams();

  const [type, setType] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [date, setDate] = React.useState(
    new Date().toISOString().split("T")[0]
  );
  const [file, setFile] = React.useState(null);
  const [message, setMessage] = React.useState("");

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const submitHanlder = async () => {
    if (type === "" || title === "" || date === "" || message === "") {
      toast.error("Please fill all the fields.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("auth_token", user.auth_token);
      formData.append("user_id", user.user_id);
      formData.append("comm_type", type);
      formData.append("comm_title", title);
      formData.append("comm_date", date);
      formData.append("message", message);
      formData.append("school_id", id);

      // For file uploads, ensure that `file` is a valid File object
      if (file) {
        formData.append("file", file);
      }

      await axiosInstance
        .post("addschoolfollowup", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          window.location.reload();
        });
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle className="opacity-95">
          Add Communication details{" "}
          <div className="text-sm opacity-60">{schoolName}</div>
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", gap: 1, flexDirection: "column", width: 400 }}
        >
          <FormControl sx={{ marginTop: "8px" }}>
            <InputLabel id="comm-type-selection">Communication Type</InputLabel>
            <Select
              labelId="comm-type-selection"
              variant="outlined"
              value={type}
              onChange={(event) => setType(event.target.value)}
              label="Communication Type"
            >
              {communicationTypes &&
                communicationTypes.map((type) => (
                  <MenuItem key={type.comm_type} value={type.comm_type}>
                    {type.comm_type}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            id="title"
            label="Title"
            variant="outlined"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            id="message"
            label="Message"
            value={message}
            multiline
            rows={8}
            onChange={(event) => setMessage(event.target.value)}
          />

          <TextField
            fullWidth
            id="date"
            label="Date"
            type="date"
            defaultValue={date}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
            onChange={(event) => setDate(event.target.value)}
            size="small"
          />

          <Button
            startIcon={<UploadFileOutlined />}
            onClick={handleButtonClick}
            variant="outlined"
          >
            Upload
          </Button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {file && (
            <div className="flex gap-2 items-center">
              <span>{file.name}</span>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setFile(null)}
              >
                Remove
              </Button>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={submitHanlder}>Submit</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
}
